export default "__VITE_ASSET__CwG2Z4Fc__"